class collectionGridItem extends HTMLElement {
  constructor() {
      super();
      this.mainCollection = document.querySelector("[js-hb-main-collection]");
      this.desktopPosition = parseInt(this.dataset.hbPositionDesk);
      this.mobilePosition = parseInt(this.dataset.hbPositionMob);

      this.init();

  };
  init() {
      this.appendGridItem();
  };

  playBannerVideos(gridItem) {
    const isDesktop = window.matchMedia("(min-width: 750px)").matches;
    const videos = gridItem.querySelectorAll(".lazy-video");

    videos.forEach((video) => {
      const shouldPlay =
        (isDesktop && video.classList.contains("Desktop_video_new")) ||
        (!isDesktop && video.classList.contains("Mobile_video_new"));

      if (!shouldPlay) {
        video.pause();
        return;
      }

      if (!video.src && video.dataset.src) {
        video.src = video.dataset.src;
        video.load();
      }

      const playVideo = () => video.play().catch(() => {});

      video.muted = true;
      video.playsInline = true;

      if (video.readyState >= 2) {
        playVideo();
      } else {
        video.addEventListener("loadeddata", playVideo, { once: true });
      }
    });
  }

  appendGridItem() {
    if (!this.mainCollection) return;
    const grid = this.mainCollection.querySelector("[js-product-grid]");

    if (!grid) return;
    const gridItem = this.querySelector("li");

    if (!gridItem) return;
    const existingGridItem = Array.from(grid.children).find(
      (child) =>
        child.tagName === "LI" &&
        child.dataset.productId === gridItem.dataset.productId &&
        child !== gridItem,
    );

    if (existingGridItem) {
      existingGridItem.remove();
    }

    const isDesktop = window.matchMedia("(min-width: 750px)").matches;

    const requestedPosition = isDesktop
      ? this.desktopPosition
      : this.mobilePosition;

    const position = Number.isFinite(requestedPosition)
      ? requestedPosition
      : this.desktopPosition;


    const gridItems = Array.from(grid.children).filter(
      (child) => child.tagName === "LI" && child !== gridItem,
    );

    const index = Number.isFinite(position)
      ? Math.max(0, position - 1)
      : gridItems.length;

    if (index >= gridItems.length) {
      grid.appendChild(gridItem);
    } else {
      grid.insertBefore(gridItem, gridItems[index]);
    }

    this.playBannerVideos(gridItem);
    
    this.remove();
  }
}

customElements.define("collection-grid-item", collectionGridItem);
